import { useMutation } from "@tanstack/react-query";
import type { Familiarity } from "@itspip/shared";
import { apiClient } from "@/lib/api-client";

export function useUpdateOkrProfile() {
  return useMutation({
    mutationFn: async (familiarity: Familiarity) => {
      const { data, error } = await apiClient.PATCH("/v1/users/me/okr-profile", {
        body: { familiarity },
      });
      if (error) {
        throw new Error(error.error.message || "Failed to update familiarity.");
      }
      return data;
    },
  });
}
